import React from 'react'
import T from 'prop-types'
import ReactDOM from 'react-dom'
import getBaseClass from './getBaseClass'

/*
* HOC for "target" elements that should be valid for drag selection
*/
const DragSelectable = WrappedComponent => {
  const BaseClass = getBaseClass(WrappedComponent)

  return class DragSelectableWrapped extends BaseClass {
    static displayName = `DragSelectable(${WrappedComponent.displayName ||
      'Component'})`

    static propTypes = {
      selectableKey: T.oneOfType([T.string, T.number]),
      getRef: T.func // TODO remove and use regular refs when React addresses the issues at the end of this https://facebook.github.io/react/docs/higher-order-components.html
    }

    static contextTypes = {
      dragSelection: T.object
    }

    componentDidMount() {
      if (this.props.selectableKey) {
        if (this.context.dragSelection) {
          this.context.dragSelection.register(
            this.props.selectableKey,
            ReactDOM.findDOMNode(this)
          )
        } else if (process.env.NODE_ENV === 'development') {
          console.warn(
            `react-base DragSelectable@componentDidMount: no context.dragSelection found: ${this
              .props.selectableKey}`
          )
        }
      }
    }

    componentWillUnmount() {
      if (this.props.selectableKey) {
        if (this.context.dragSelection) {
          this.context.dragSelection.unregister(
            this.props.selectableKey,
            ReactDOM.findDOMNode(this)
          )
        } else if (process.env.NODE_ENV === 'development') {
          console.warn(
            `react-base DragSelectable@componentWillUnmount: no context.dragSelection found: ${this
              .props.selectableKey}`
          )
        }
      }
    }

    render() {
      const refProps = {}
      refProps[
        WrappedComponent.propTypes && WrappedComponent.propTypes.getRef
          ? 'getRef'
          : 'ref'
      ] = this.props.getRef
      return <WrappedComponent {...refProps} {...this.props} />
    }
  }
}

export default DragSelectable
